import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { NovaIcon } from 'components/ui/novaIcon';
import { WarningIcon } from 'assets/icons/v2';

type Props = {
  onUpgradeClick: () => void;
};

export const NoTokensAlert = ({ onUpgradeClick }: Props): ReactElement => {
  return (
    <Box
      bg="background.primary"
      borderRadius="5px"
      border="default"
      borderColor="border.accent"
      p="15px"
      w="full"
    >
      <VStack gap="15px" align="stretch">
        <HStack gap="10px" align="flex-start">
          <Box flexShrink={0}>
            <NovaIcon icon={WarningIcon} size="m" color="icon.warning" aria-hidden />
          </Box>
          <VStack gap="5px" align="flex-start" flex={1}>
            <Text textStyle="body.s.medium" color="text.primary" lineHeight="1.3">
              Du hast dein Kontingent für die AI-Arbeitsblätter verbraucht
            </Text>
            <Text textStyle="body.s.regular" color="text.primary" lineHeight="1.3">
              Du hast kein Kontingent mehr für die Generierung von AI-Arbeitsblättern. Upgrade dein
              AI-Abo, um mehr Arbeitsblätter zu erstellen.
            </Text>
          </VStack>
        </HStack>

        <Box>
          <Button
            variant="primary"
            backgroundColor="background.accent"
            onClick={onUpgradeClick}
            textStyle="body.s.regular"
            fontWeight="normal"
            px="15px"
            py="xs"
          >
            AI-Abo upgraden
          </Button>
        </Box>
      </VStack>
    </Box>
  );
};
